import React, { useEffect } from 'react';
import bannerImage from '../img/banner.jpg';
import './Infosxc.css';

export default function Infosxc() {
  useEffect(() => {
    // Initialize FinisherHeader with exact config provided
    const initFinisher = () => {
      if (window.FinisherHeader) {
        try {
          new window.FinisherHeader({
            className: 'infosxc-section',
            count: 100,
            size: {
              min: 2,
              max: 8,
              pulse: 0
            },
            speed: {
              x: {
                min: 0,
                max: 0.4
              },
              y: {
                min: 0,
                max: 0.6
              }
            },
            colors: {
              background: "rgba(0, 0, 0, 0)",
              particles: [
                "#fbfcca",
                "#d7f3fe",
                "#ffd0a7"
              ]
            },
            blending: "overlay",
            opacity: {
              center: 1,
              edge: 0
            },
            skew: -2,
            shapes: [
              "c"
            ]
          });
          console.log('FinisherHeader initialized for Infosxc');
        } catch (error) {
          console.error('Error initializing FinisherHeader:', error);
        }
      } else {
        // Retry if library not loaded yet
        setTimeout(initFinisher, 100);
      }
    };
    
    initFinisher();
  }, []);

  return (
    <div className="infosxc-section">
      {/* Banner image with particles overlay */}
      <img
        src={bannerImage}
        alt="Banner"
      />
    </div>
  );
}
